import { useSubmit } from "@certn/api";
import {
  DropdownMenu,
  GhostIconButton,
  MenuItem,
  MenuSection,
  showToast,
  Text,
} from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { useData } from "./new-questionnaire-template/hooks/useData";
import { Schemas } from "../../types";
interface Props {
  question: Schemas["QuestionnaireTemplatesList"];
  count?: number;
}

export function ActionsDropdown({ question: { id, is_active }, count }: Props) {
  const { mutate } = useData();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { submit: submitActivate, isSubmitting: isSubmittingActivate } =
    useSubmit(
      `/api/internal/client-portal/questionnaire-templates/${id}/activate/`,
      {
        showToastOnError: true,
        onSuccess: async () => {
          showToast(t("Template successfully activated"), {
            type: "success",
          });
          mutate();
        },
      }
    );
  const { submit: submitDeactivate, isSubmitting: isSubmittingDeactivate } =
    useSubmit(
      `/api/internal/client-portal/questionnaire-templates/${id}/deactivate/`,
      {
        showToastOnError: true,
        onSuccess: async () => {
          showToast(t("Template successfully deactivated"), {
            type: "success",
          });
          mutate();
        },
      }
    );

  const disabledKeys = [
    ...(isSubmittingActivate ? ["activate-template"] : []),
    ...(isSubmittingDeactivate ? ["deactivate-template"] : []),
  ];

  return (
    <DropdownMenu
      disabledKeys={disabledKeys}
      triggerButton={
        <GhostIconButton
          testID="questionnaire-templates-item-expand-button"
          size="small"
          icon="more_horiz"
          aria-label={t("Expand menu")}
        />
      }
      placement="bottom right"
      onItemAction={async (key) => {
        switch (key) {
          case "edit-template":
            navigate(`/settings/questionnaire-templates/${id}`);
            break;
          case "deactivate-template":
            await submitDeactivate();
            break;
          case "activate-template":
            await submitActivate();
            break;
        }
      }}
    >
      <MenuSection>
        <MenuItem id="edit-template" testID="edit-template">
          <Text style="input/text-field">{t("Edit")}</Text>
        </MenuItem>
        {!!count && count >= 2 && is_active && (
          <MenuItem id="deactivate-template" testID="deactivate-template">
            <Text color="text-danger" style="input/text-field">
              {t("Deactivate")}
            </Text>
          </MenuItem>
        )}
        {!is_active && (
          <MenuItem id="activate-template" testID="activate-template">
            <Text style="input/text-field">{t("Activate")}</Text>
          </MenuItem>
        )}
      </MenuSection>
    </DropdownMenu>
  );
}
